export function clearDefaultValues(
  obj: Record<string, any>,
  emptyDefaultValues: Record<string, any>
): Record<string, any> {
  return Object.keys(obj).reduce(
    (acc, key) => ({ ...acc, [key]: emptyDefaultValues[key] }),
    {}
  );
}
